import parsePhoneNumberFromString from 'libphonenumber-js';
import React, { useEffect, useRef, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { RiSave3Fill, RiCloseCircleLine } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import { emailSliceAction } from '../../store/emailSlice';

const MailInfo = () => {
    const dispatch = useDispatch()
    const contactAttributes = useSelector((state:any)=>{return state.emailSlice.contactAttributes});
    const selectedContactDetails = useSelector((state:any)=>{return state.emailSlice.selectedContactDetails})
    const selectedMenu = useSelector((state:any)=>{return state.emailSlice.selectedMenu})
    const connections = useSelector((state:any)=>{return state.emailSlice.emailConnections})
    let wrapupCodes = selectedContactDetails?.wrapupData?.wrapupCodes
    let subAccounts = selectedContactDetails?.wrapupData?.subAccounts
    const [ticketNumber, setTicketNumber] = useState("")
    const [wrapupCode, setWrapupCode] = useState("")
    const [subAccount, setSubAccount] = useState("")
    const [ticketErrorMessage, setTicketErrorMessage] = useState("")
    const [warpupCodeErrorMessage, setWarpupCodeErrorMessage] = useState("")
    const [subAccountErrorMessage, setSubAccountErrorMessage] = useState("")
    const timerRef = useRef<any>(null);
    const [alertDisplay, setAlertDisplay] = useState(false)
    
    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    const onChangeTicketNumber = (event:any) => {
        setTicketErrorMessage("")
        setTicketNumber(event.target.value)
    }

    const onChangeWrapupCode = (event:any) => {
        setWarpupCodeErrorMessage("")
        setWrapupCode(event.target.value)
    }

    const onChangeSubAccount = (event:any) => {
        setSubAccountErrorMessage("")
        setSubAccount(event.target.value)
    }

    const onCloseContact = async() => {
        if(selectedContactDetails?.contactId) {
            const remainingContact = contactAttributes.filter((item:any) => item.contactId !== selectedContactDetails?.contactId)
            if(remainingContact.length > 0) {
                dispatch(emailSliceAction.removeContactAttributes(remainingContact))
            } else {
                dispatch(emailSliceAction.removeContactAttributes(remainingContact))
            }
            dispatch(emailSliceAction.setSelectedContactDetails(""))
            dispatch(emailSliceAction.setEmailDetails(""))
            let selectedConnection = connections.filter((item:any) => selectedContactDetails.contactId === item.controller.contactId)[0]
            try{
                await selectedConnection.controller.disconnectParticipant()
                await selectedConnection.controller.contactObject.clear()
            }catch(e){
                console.log(e)
                console.log( "selected ",selectedConnection.controller.selectedConnection)
                await selectedConnection.controller.selectedConnection.destroy() 
                selectedConnection.controller.contactObject.onEnded(()=> {
                    selectedConnection.controller.contactObject.clear()
                });
            }       
            

        }
    }

    const onSaveWrapupCode = () => {
        if(ticketNumber === "") {
            setTicketErrorMessage("Enter ticket number")
            return false;
        } else if(wrapupCodes?.length > 0 && wrapupCode === "") {
            setWarpupCodeErrorMessage("Select wrap-up code")
            return false;
        } else if(subAccount === "" && selectedContactDetails?.accountName === "Mobox") {
            setSubAccountErrorMessage("Select sub account")
            return false;
        }

        let finalTicketNumber = ticketNumber;
        if (process.env.REACT_APP_AWS_CCP_REGION === "eu-west-2" && /^\d*$/.test(ticketNumber)) {
			finalTicketNumber = "INC-" + ticketNumber;
		}
        let requestData:any = {
            contact_id : selectedContactDetails?.contactId,
            ticket_number : finalTicketNumber,
            contactDirection : selectedContactDetails?.contactDirection,
        }
        
        if(selectedContactDetails?.contactDirection === 'outbound') {
            if (subAccount) requestData.ob_account = subAccount;
            if (selectedContactDetails.accountName === "Mobox") requestData.ob_country_code = parsePhoneNumberFromString(selectedContactDetails.phone)?.countryCallingCode.toString()
            if (wrapupCode) requestData.ob_wrapcode = wrapupCode;
        } else if (selectedContactDetails?.contactDirection === 'inbound') {
            if (wrapupCode) requestData.ib_wrapcode = wrapupCode;
        }
        if(selectedContactDetails?.contactId) {
            return fetch(process.env.REACT_APP_API_GETWAY_URL + "set-wrap-code", {
                method: "POST",
                body: JSON.stringify(requestData),
            }).then(resp => {
                if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
                return resp.json();
            }).then(resp => {
                if (!resp.success) throw new Error("API returned failure code!");
                setTicketNumber("")
                setWrapupCode("")
                setSubAccount("")
                setAlertDisplay(true)
                timerRef.current = setTimeout(() => setAlertDisplay(false), 5000);
                return;
            });
        }
    }
    return (
        <React.Fragment>
            {(selectedContactDetails && selectedMenu === 'active') && 
                <div className="card call-info collapse show mt-3" id="chat_info">
                    
                    <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className='m-0'>Mail details</h6>
                    </div>
                    {alertDisplay &&
                        <Alert variant="success" onClose={() => setAlertDisplay(false)} dismissible>
                            <strong>Data saved successfully</strong>
                        </Alert>
                    }
                    <ul className='calling-data list-unstyled'>
                        <li className="mr-5">
                            <label>Name:</label> &nbsp;
                            <span>{ selectedContactDetails?.contactAttributes?.Name?.value || 'unknown' }</span>
                        </li>
                        <li>
                            <label>Email:</label> &nbsp;
                            <span>{ selectedContactDetails?.contactAttributes?.Sender?.value || 'unknown' }</span>
                        </li>
                        <li>
                            <label>Queue:</label> &nbsp;
                            <span>{ selectedContactDetails?.queueName || 'unknown' }</span>
                        </li>
                        <li>
                            <label>Case number:</label> &nbsp;
                            <span>{ selectedContactDetails?.contactAttributes?.CaseNumber?.value || 'unknown' }</span>
                        </li>
                        <li>
                            <label>Language:</label> &nbsp;
                            <span>{ selectedContactDetails?.contactAttributes?.Language?.value || 'unknown' }</span>
                        </li>
                    </ul>
                    
                        <div className="row calling-data">
                            <div className='col-1'>
                                <h6 className='m-0'>Wrap-up</h6>
                            </div>
                            <div className="col-2">
                                <input onChange={(event) => { onChangeTicketNumber(event) }} value={ticketNumber} type="text" className={`form-control form-control-sm ${(ticketErrorMessage !== "")?"is-invalid":""}`} placeholder="Ticket no." name="" />
                                {ticketErrorMessage && <div className="invalid-feedback">Enter ticket number</div>}
                            </div>
                            {wrapupCodes?.length > 0 && 
                            <div className="col-2">
                                <select onChange={(event) => { onChangeWrapupCode(event) }} className={`form-control form-select-sm ${(warpupCodeErrorMessage !== "")?"is-invalid":""}`}>
                                    <option value="">-- Select wrap-up --</option>
                                    {wrapupCodes.map((code:any, index:number) => {
                                        return (<option key={index} value={code}>{code}</option>)
                                    })}
                                </select>
                                {warpupCodeErrorMessage && <div className="invalid-feedback">Select wrap-up code</div>}
                            </div>
                            }
                            {subAccounts?.length > 0 && 
                                <div className="form-group mb-3">
                                    <label className='mb-2'>Account</label>
                                    <select onChange={(event) => { onChangeSubAccount(event) }} className={`form-control form-select-sm ${(subAccountErrorMessage !== "")?"is-invalid":""}`}>
                                        <option value="">-----</option>
                                        {subAccounts.map((code:any, index:number) => {
                                            return (<option key={index} value={code}>{code}</option>)
                                        })}
                                    </select>
                                    {subAccountErrorMessage && <div className="invalid-feedback">Select account</div>}
                                </div>
                            }
                            <div className="col-4">
                                <button onClick={()=>{ onSaveWrapupCode() }} className="btn btn-sm btn-primary me-2"><RiSave3Fill /> Save</button>
                                <button onClick={()=>{ onCloseContact() }} className="btn btn-sm btn-danger"><RiCloseCircleLine /> Close</button>
                            </div>
                        </div>
                
    
                    </div>
                </div>
            }
        </React.Fragment>          
    )
}
export default MailInfo;